import { BrandState, BrandResponseProps } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { getBrand, createBrand, removeBrand, updateBrand } from './brandServices';

export const initialState: BrandState = {
    data: {} as BrandResponseProps,
    status: "loading",
    error: {}
}

export const BrandSlice = createSlice({
    name: 'role',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBrand.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getBrand.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(getBrand.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
            .addCase(createBrand.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(createBrand.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(createBrand.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
            .addCase(removeBrand.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(removeBrand.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(removeBrand.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
            .addCase(updateBrand.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(updateBrand.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(updateBrand.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const BrandsReducer = BrandSlice.reducer